import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import Slider from "react-slick";

function TurboTreasure2k25(props) {
    const { app: {
        brandId
    }, theme } = props;

    const { showOnlyOnFomo } = theme.config;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const settings = {
        loop: true,
        arrows: true,
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        initialSlide: 0,
        centerPadding: '20px'
    };

    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : 'IW247';

    return (
        <>
            <InformationWrapper>
                    <TitleText>
                        <p className='boldText'>Play fast and win faster! This July to August, iW247 and Turbo Games bring you the ultimate rush with the <br /> <span className='bgMultipleColor'>Turbo Treasure</span> leaderboard promo.</p>
                        <p>Turn your quick bets into Weekly and monthly prizes.</p>
                    </TitleText>
                <ImageWrapper>
                    <Container>
                          <MainTitle className='bgMultipleColorTitle'>How to Participate</MainTitle>
                          <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasureBonusDeskFirstSec}`}
                                alt="How to participate"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                           />
                    </Container>
                </ImageWrapper> 

                <PriceBreakDown>
                    <MainTitle className='bgMultipleColorTitle'>weekly prize pool</MainTitle>
                    <SliderWrapper>
                        <Slider {...settings}>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure1st}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure2nd}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure3rd}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure4th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure5th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure6th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure7th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure8th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure9th}`}/></div>
                            <div><img src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasure10th}`}/></div>
                        </Slider>
                    </SliderWrapper>
                </PriceBreakDown>

                <KeyDetailsSec>
                    <MainTitle className='bgMultipleColorTitle'>Monthly prize Pool</MainTitle>
                    <p className='textNormal'>Monthly Prize (Random selector from top players in the weekly leaderboard)</p>
                    <KeyDetailsSecWrap>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.turboTreasureMonthlyPricePool}`}
                            alt="Monthly prize Pool"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>
                <TermsAndCondition>
                    <MainTitle className='bgMultipleColorTitle'>Terms & Conditions</MainTitle>
                    <ul>
                        <li>Only bets on Turbo Games count (e.g. <span className='boldText'>CrashX, Limbo, Tower Legend</span>).</li>
 
                        <li>Leaderboard ranks are based on <span className='boldText'>total turnover</span>.</li>

                        <li>Weekly prizes are paid as bonuses</li>

                        <li>Winners must complete KYC and provide a valid USDT wallet address if required</li>

                        <li>Leaderboards reset at <span className='boldText'>midnight IST</span> every day.</li>

                        <li>KYC verification required to receive any prize.</li>

                        <li>{domain} reserves the right to amend <span className='boldText'>the campaign at any time</span>.</li>
                    </ul>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}



export default withTheme(withAppContext(TurboTreasure2k25));

const TermsAndCondition = styled.div`
    width: 65%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    & li {
        color: #FFF;
        text-align: justify;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 116.667% */
        text-transform: capitalize;
        list-style-type: decimal;
        padding-bottom: 1.5rem;
    }
`;

const SliderWrapper = styled.div`
    width: 85%;
    margin: 0 auto;

    .slick-slide {
        padding: 0 15px;
    }

    .slick-slide img {
        display: block;
        width: 100%;
        transition: transform .5s; /* Animation */

        :hover {
            transform: scale(0.8);
            border: 3px solid #ffffff;
            border-radius: 1rem;
        }

        :focus-visible {
            outline: none;
        }
        :focus {
            outline: none;
        }
    }

    .slick-prev {
        left: -65px;
        top: 43%;
    }

    .slick-next {
        right: -25px;
        top: 43%;
    }

    .slick-prev:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/prevSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-next:before {
        content: "";
        width: 60px;
        height: 60px;
        display: inline-block;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/nextSlideJackpot.png);
        background-size: cover;
        background-position:center center;
        background-repeat: no-repeat;
        opacity: unset;
    }

    .slick-dots {
        bottom: -40px;

        li {
            width: 15px;
            height: 15px;

                button {
                font-size: 0;
                width: auto; 
                height: auto;
            }
        }

        li button:before {
            color: #fff;
            opacity: unset;
            width: 10px;
            height: 10px;
            font-size: unset;
            line-height: normal;
            border-radius: 20px;
            border: 1px solid #fff;
            background: #000;
        }

        li.slick-active button:before {
            opacity: unset;
            color: #DB1D1D;
            background: #DB1D1D;
        }
    }
`;

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.turboTreasureMainInnerBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .bgMultipleColor {
        background-color: #fff;
        color: #000;
        padding: 2px 3px;
        position: relative;
        z-index: 1;
        margin-right: 5px;

        ::after {
            content: "";
            width: 100%;
            height: 100%;
            background-color: #FF003A;
            position: absolute;
            left: 3px;
            top: 4px;
            z-index: -1;
        }
    }

    .boldText {
        font-weight: 700;
    }

    .boldTextLite {
        color: ${theme('palette.informationWrapperPromoBoldText')};
        font-weight: 400;
    }

    .shadowLine {
        background: radial-gradient(37.24% 47.13% at 50% 0%, #051829 0%, rgba(1, 4, 6, 0.00) 100%);
        -webkit-backdrop-filter: blur(6.849999904632568px);
        backdrop-filter: blur(6.849999904632568px);
        width: 100%;
        padding-top: 2rem;
    }

    .purple-strong {
        color: ${theme('palette.weeklyLeaderboardText')};
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 25px; /* 166.667% */
        text-transform: capitalize;
        margin: 3px 0px;
    }

    h2 {
        color: #E6FF00;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        background: ${theme('palette.LiveJackPot2025InformationWrapperH2Text')};
        background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2TextClip')};
        -webkit-background-clip: ${theme('palette.LiveJackPot2025InformationWrapperH2WebkitClip')};
        -webkit-text-fill-color: ${theme('palette.LiveJackPot2025InformationWrapperH2TextWebkitFill')};
    }

    .paddingTopBtm {
        margin: 0 auto;
        margin-bottom: 2rem;
    }
`;

const PriceBreakDown = styled.div`
    width: 80%;
    padding: 2rem 0;
    position: relative;
    margin: auto;
    text-align: center;
`;



const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${theme('palette.liveJackpotTittleTextPadding')};
    position: relative;
    gap: 15px;
    /* margin-bottom: 2rem; */


    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        text-transform: capitalize;
        margin: 0;
    }

    .mt-10 {
        margin-top: 15px;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
    position: relative;


    img {
        width: 93px;
    }

    .customMargin {
        margin: -7px 0px -20px 0px;
    }
`;


const Container = styled.div`
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: inline-block;

    & img {
      width: 70%;
      height: auto;
    }

`;

const MainTitle = styled.h4`
    color: ${theme('palette.weeklyLeaderboardText')};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 35px; /* 175% */
    text-transform: capitalize;
    margin: 3px 0px 15px 0px;

    &.bgMultipleColorTitle {
        display: inline-block;
        background-color: #FF003A;
        color: #FF003A;
        padding: 2px 3px;
        position: relative;
        z-index: 1;
        padding-bottom: 8px;
        padding-right: 10px;
        padding-left: 5px;
        line-height: normal;
        margin-bottom: 1.5rem;

        ::before {
            content: "";
            width: 100%;
            height: 100%;
            background-color: #fff;
            position: absolute;
            left: -3px;
            top: -4px;
            z-index: -1;
        }
    }
`


const KeyDetailsSec = styled.div`
    width: 50%;
    display: inline-block;
    margin: 0 auto;
    margin-top: 4rem;
    margin-bottom: 4rem;
    text-align: center;

    .textNormal {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 186.667% */
        text-transform: capitalize;
        margin: 0;
        margin-bottom: 2rem;
        margin-top: -10px;
    }
    
`

const KeyDetailsSecWrap = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;

    img {
        width: 600px;
        max-width: 100%;
    }
`